import { loadPPGResults } from './actions';

const allActions = {
  loadPPGResults,
};

export { allActions as ppgActions };
export { reducer as ppgReducer } from './slice';
